var map = {
	"./$GMUSIC-icon.png": 1000,
	"./BAT-icon.png": 1001,
	"./BTC-icon.png": 1002,
	"./BXC-icon.png": 1003,
	"./CC-icon.png": 503,
	"./DistTest-icon.png": 1353,
	"./ETH-icon.png": 1004,
	"./GALA-icon.png": 983,
	"./GALA[ETH]-icon.png": 1354,
	"./GALA[GYRI]-icon.png": 1355,
	"./MTRM-icon.png": 1356,
	"./MTRM[ETH]-icon.png": 1357,
	"./MTRM[GYRI]-icon.png": 1358,
	"./NODETESTCOIN-icon.png": 1359,
	"./NODETESTCOIN-transparent-icon.png": 1360,
	"./SILK-icon.png": 1005,
	"./SILK[GYRI]-icon.png": 1361,
	"./TANK-icon.png": 1006,
	"./TCTESTCOIN-icon.png": 1362,
	"./TEST-icon.png": 1363,
	"./TOWN-icon.png": 1007,
	"./USD-icon.png": 751,
	"./mastercard-icon.png": 501,
	"./simplex-icon.png": 1008,
	"./visa-icon.png": 502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 650;